import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

export const ArticleParallaxContentGridCol = styled.div`
  grid-column: 1 / -1;
  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;
